import Svg, { Circle, Path } from 'react-native-svg'

const SmileyHappySVG = ({
  fillColor = '#5D5D5A',
  backgroundColor = 'transparent',
}: {
  fillColor?: string
  backgroundColor?: string
}) => {
  return (
    <Svg width="49" height="49" viewBox="0 0 49 49" fill="none">
      <Circle cx="26" cy="26" r="16" fill={backgroundColor} />
      <Path
        d="M27.6563 8.5C24.362 8.5 21.1416 9.47687 18.4025 11.3071C15.6634 13.1373 13.5286 15.7386 12.2679 18.7822C11.0072 21.8257 10.6774 25.1747 11.3201 28.4057C11.9627 31.6367 13.5491 34.6046 15.8785 36.934C18.2079 39.2634 21.1758 40.8498 24.4068 41.4925C27.6378 42.1351 30.9868 41.8053 34.0303 40.5446C37.0739 39.2839 39.6752 37.1491 41.5054 34.41C43.3356 31.6709 44.3125 28.4505 44.3125 25.1562C44.3078 20.7402 42.5515 16.5063 39.4289 13.3837C36.3062 10.261 32.0723 8.50466 27.6563 8.5ZM27.6563 39.25C24.8688 39.25 22.1439 38.4234 19.8262 36.8748C17.5085 35.3261 15.7021 33.125 14.6353 30.5497C13.5686 27.9744 13.2895 25.1406 13.8333 22.4067C14.3771 19.6728 15.7194 17.1615 17.6905 15.1905C19.6615 13.2194 22.1728 11.8771 24.9067 11.3333C27.6406 10.7895 30.4744 11.0686 33.0497 12.1353C35.625 13.202 37.8261 15.0085 39.3748 17.3262C40.9234 19.6439 41.75 22.3688 41.75 25.1562C41.7458 28.8928 40.2595 32.4752 37.6174 35.1174C34.9752 37.7595 31.3929 39.2458 27.6563 39.25ZM35.3003 28.6682C35.4713 29.306 35.3306 29.991 35.235 30.6444C34.969 32.4631 33.6864 36.1562 27.6563 36.1562C20.983 36.1562 20.0867 31.2889 19.973 29.6745C19.9489 29.3319 19.8968 28.9821 19.9785 28.6484C20.0196 28.4806 20.0943 28.3228 20.198 28.1846C20.3016 28.0463 20.4322 27.9305 20.5818 27.844C20.7314 27.7575 21.0703 27.7228 21.0703 27.7228C21.0703 27.7228 21.3809 27.7227 21.58 27.7228C21.779 27.7229 25.2833 27.7541 27.6563 27.7622C30.0292 27.7703 34.2005 27.7148 34.3423 27.7622C34.4841 27.8096 34.4088 27.7202 34.7031 27.8901C34.8437 27.9712 34.9661 28.0774 35.0652 28.202C35.1737 28.3383 35.2543 28.4966 35.3003 28.6682Z"
        fill={fillColor}
      />
      <Path
        d="M19 22L19.1396 21.8388C20.4275 20.3517 22.7417 20.3745 24 21.8867"
        stroke={fillColor}
        stroke-width="3"
        stroke-linecap="round"
      />
      <Path
        d="M32 22L32.1396 21.8388C33.4275 20.3517 35.7417 20.3745 37 21.8867"
        stroke={fillColor}
        stroke-width="3"
        stroke-linecap="round"
      />
      <Path
        d="M27.7597 33.5C31.4792 33.5 32.2711 31.9681 32.4354 31.2131C32.4939 30.9446 32.5776 30.6477 32.4759 30.3924C32.4475 30.3212 32.3978 30.2555 32.3308 30.1989C32.2697 30.1472 32.1941 30.1031 32.1074 30.0695C31.9258 29.999 31.9723 30.0361 31.8848 30.0164C31.7973 29.9967 29.2237 30.0197 27.7597 30.0164C26.2956 30.013 24.1336 30.0001 24.0108 30H23.6963C23.6963 30 23.4872 30.0144 23.3949 30.0503C23.3026 30.0862 23.222 30.1343 23.1581 30.1917C23.0941 30.249 23.0481 30.3145 23.0227 30.3842C22.9736 30.5189 23.0044 30.6691 23.0195 30.8117C23.0904 31.4833 23.6458 33.5 27.7597 33.5Z"
        fill="white"
      />
    </Svg>
  )
}

export default SmileyHappySVG
